import { motion } from "framer-motion";

const LOGO_URL = "/logo.png";
const BG_URL = "https://images.pexels.com/photos/5988169/pexels-photo-5988169.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export default function HeroSection() {
  return (
    <section
      id="hero"
      data-testid="hero-section"
      className="relative min-h-screen flex flex-col items-center justify-center overflow-hidden"
    >
      {/* Background layers */}
      <div className="absolute inset-0 bg-[#0a0a0a]">
        <img
          src={BG_URL}
          alt=""
          className="absolute inset-0 w-full h-full object-cover opacity-[0.07]"
        />
        <div className="absolute inset-0 hero-bg-overlay" />
        <div className="absolute bottom-0 left-0 right-0 h-40 bg-gradient-to-t from-[#0a0a0a] to-transparent" />
      </div>

      {/* Content */}
      <div className="relative z-10 flex flex-col items-center text-center px-6 pt-20">
        <motion.img
          src={LOGO_URL}
          alt="Vicki Ann's Luxurious Gifts"
          className="w-72 sm:w-80 md:w-[480px] mb-12"
          initial={{ opacity: 0, scale: 0.85 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1.2, ease: "easeOut" }}
        />

        <motion.h1
          className="font-great-vibes text-[#D4AF37] text-3xl sm:text-4xl md:text-6xl mb-6 leading-tight"
          initial={{ opacity: 0, y: 25 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.5 }}
        >
          Where Every Golden Egg Reveals a Designer Dream
        </motion.h1>

        <motion.p
          className="font-montserrat text-white/50 text-sm md:text-base max-w-lg mb-12 tracking-wide leading-relaxed"
          initial={{ opacity: 0, y: 25 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.8 }}
        >
          Experience the magic of luxury mystery scoops — designer-inspired
          purses, golden eggs, and beautiful pearl accessories curated just for
          you.
        </motion.p>

        <motion.a
          href="#menu"
          data-testid="hero-cta-btn"
          className="btn-gold px-10 py-4 rounded-full text-sm font-montserrat"
          initial={{ opacity: 0, y: 25 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 1.1 }}
        >
          Start Your Scoop
        </motion.a>

        {/* Scroll indicator */}
        <motion.div
          className="absolute bottom-10 left-1/2 -translate-x-1/2"
          animate={{ y: [0, 8, 0] }}
          transition={{ duration: 2, repeat: Infinity }}
        >
          <div className="w-6 h-10 rounded-full border-2 border-[#D4AF37]/30 flex items-start justify-center pt-2">
            <div className="w-1.5 h-1.5 rounded-full bg-[#D4AF37]/60" />
          </div>
        </motion.div>
      </div>
    </section>
  );
}
